import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-header-mobile',
    templateUrl: 'header-mobile.component.html',
    styles: [],
    standalone: false
})
export class HeaderMobileComponent {
  @Input() homeButtonText?: string; 
  @Input() title?: string = ''; 
  @Input() icon?: string; 
  @Output() homeClicked = new EventEmitter<void>();
  @Output() backClicked = new EventEmitter<void>();

  // advancedSearch() {
  //   this.backClicked.emit(); 
  // }

  // homeButtonClick() {
  //   this.homeClicked.emit(); 
  // }
}
